import { createContext, useContext, useState } from "react";

type AuthErrorContextType = {
  hasAuthError: boolean;
  setAuthError: (value: boolean) => void;
};

const AuthErrorContext = createContext<AuthErrorContextType | null>(null);

export function AuthErrorProvider({ children }: { children: React.ReactNode }) {
  const [hasAuthError, setAuthError] = useState(false);
  return <AuthErrorContext.Provider value={{ hasAuthError, setAuthError }}>{children}</AuthErrorContext.Provider>;
}

export function useAuthError() {
  const ctx = useContext(AuthErrorContext);
  if (!ctx) throw new Error("useAuthError must be used within AuthErrorProvider");
  return ctx;
}
